import React from 'react';
import { Menu, X, Briefcase } from 'lucide-react';
import { Link } from 'react-router-dom';
import { getDefaultPath } from './ProtectedRoute';
import LanguageToggle from './LanguageToggle';
import NotificationBell from './NotificationBell';

export default function Navbar({
    activeUser,
    notifications,
    onMarkRead,
    onMarkAllRead,
    onDeleteNotification,
    onNotificationClick,
    mobileMenuOpen,
    setMobileMenuOpen,
    hasMore,
    loadMore,
    loadingMore,
    totalCount
}) {
    const userRole = activeUser?.role || 'Admin';

    return (
        <header className="bg-white border-b shadow-sm sticky top-0 z-40">
            <div className="flex items-center justify-between px-6 md:px-8 h-16">
                {/* Left Section: Logo & Role Tag */}
                <div className="flex items-center gap-4">
                    {/* Mobile Menu Toggle */}
                    <button
                        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        className="lg:hidden p-2 hover:bg-gray-100 rounded-lg text-gray-600"
                    >
                        {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                    </button>

                    {/* Logo */}
                    <Link to={getDefaultPath(userRole)} className="flex items-center gap-3 hover:opacity-90 transition-opacity">
                        <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-xl flex items-center justify-center shrink-0 shadow-sm">
                            <Briefcase className="w-5 h-5 text-white" />
                        </div>
                        <div className="hidden sm:block whitespace-nowrap">
                            <h1 className="font-bold text-gray-900 leading-tight">Demo </h1>
                            <p className="text-[10px] text-gray-500 tracking-wider uppercase">CRM</p>
                        </div>
                    </Link>

                    {/* Role Badge */}
                    <div className="hidden lg:flex items-center ml-2 border-l pl-4 border-gray-200">
                        <span
                            className={`px-3 py-1 rounded-full text-xs font-bold whitespace-nowrap ${userRole === 'Owner' || userRole === 'Admin'
                                ? 'bg-purple-100 text-purple-700'
                                : userRole === 'Sales'
                                    ? 'bg-green-100 text-green-700'
                                    : 'bg-amber-100 text-amber-700'
                                }`}
                        >
                            {userRole}
                        </span>
                    </div>
                </div>

                {/* Right Section: Language Toggle, Notifications & Profile */}
                <div className="flex items-center gap-2 sm:gap-4 scale-90 sm:scale-100 origin-right">
                    <div className="flex items-center gap-2">
                        <LanguageToggle />
                        <NotificationBell
                            notifications={notifications}
                            onMarkRead={onMarkRead}
                            onMarkAllRead={onMarkAllRead}
                            onDelete={onDeleteNotification}
                            onNotificationClick={onNotificationClick}
                            currentUser={activeUser}
                            hasMore={hasMore}
                            loadMore={loadMore}
                            loadingMore={loadingMore}
                            totalCount={totalCount}
                        />
                    </div>
                </div>
            </div>
        </header>
    );
}
